// extracted by mini-css-extract-plugin
export default {"h2":"Participants_h2__4JkSG","table":"Participants_table__EkDJE","link":"Participants_link__WtlTi","arrowIcon":"Participants_arrowIcon__5Ci3Q","td":"Participants_td__q2b35"};